export default {"src":"/_next/static/media/retail-icon-selected.45476fc6.svg","height":75,"width":115,"blurWidth":0,"blurHeight":0};